
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gaming",
      function () {
        return require("private-next-pages/gaming.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gaming"])
      });
    }
  